(() => {
  if (customElements.get('ss-collector-invite')) return;
  class CollectorInvite extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('.ss-invite-teaser');
      this.key = 'ss-collector-invitation-v1';
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelectorAll('[data-invite-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), { signal }));
      this.querySelector('[data-invite-dismiss]').addEventListener('click', () => this.dismiss(), { signal });
      this.querySelector('[data-invite-open]').addEventListener('click', () => this.open(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow ?? '';
        this.dismiss();
        this.previousFocus?.focus({ preventScroll: true });
      }, { signal });
      const response = location.hash.includes('SSCollectorSignup-') && this.querySelector('[data-invite-success], [data-invite-error]');
      if (response) {
        if (this.querySelector('[data-invite-success]')) this.store({ subscribed: true });
        this.open(); return;
      }
      if (this.dataset.preview === 'true') {
        if (matchMedia('(max-width:749px)').matches) this.teaser.hidden = false;
        else this.open();
        return;
      }
      const saved = this.read();
      if (saved.subscribed || Date.now() - (saved.seen || 0) < Number(this.dataset.days) * 86400000) return;
      try { if (sessionStorage.getItem(this.key)) return; } catch {}
      this.timer = setTimeout(() => { this.ready = true; this.check(); }, Number(this.dataset.delay) * 1000);
      addEventListener('scroll', () => this.check(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.check(), { signal });
    }
    read() { try { return JSON.parse(localStorage.getItem(this.key)) || {}; } catch { return {}; } }
    store(value) { try { localStorage.setItem(this.key, JSON.stringify(value)); } catch {} }
    busy() {
      return document.hidden || document.querySelector('dialog[open], details.menu-opening, details[open] .search-modal, cart-drawer.active, [data-filters].is-open, [data-lightbox].is-open') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
    }
    check() {
      if (!this.ready || this.offered) return;
      if (document.hidden || scrollY < Math.min(450, innerHeight * .55)) return;
      if (this.busy()) {
        clearTimeout(this.retry); this.retry = setTimeout(() => this.check(), 4000); return;
      }
      this.offered = true;
      this.store({ seen: Date.now() });
      try { sessionStorage.setItem(this.key, 'seen'); } catch {}
      if (matchMedia('(max-width:749px)').matches) this.teaser.hidden = false;
      else this.open();
    }
    open() {
      if (this.dialog.open || !this.dialog.showModal) return;
      this.teaser.hidden = true;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    dismiss() {
      this.offered = true;
      this.teaser.hidden = true;
      if (!this.read().subscribed) this.store({ seen: Date.now() });
      try { sessionStorage.setItem(this.key, 'seen'); } catch {}
      clearTimeout(this.timer); clearTimeout(this.retry);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      clearTimeout(this.timer); clearTimeout(this.retry); this.abort?.abort();
    }
  }
  customElements.define('ss-collector-invite', CollectorInvite);
})();
